module.exports = __webpack_public_path__ + "img/ticket-management.2eb0ebbd.svg";